import { Button, Grid, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const WelcomeIntro = ({mainImage,introText,slug}) => {
  
  return (
    <Grid container spacing={4} sx={{marginTop:"16px"}} alignItems="flex-start">
        <Grid size={7}>
            <Typography variant="body1" color="secondary" fontWeight={400} sx={{lineHeight:"1.7",fontSize:"1.05rem"}} dangerouslySetInnerHTML={{ __html: introText }}/>
            {
              slug?.pos === 0 &&
              <Button component={Link} to={`${slug?.last}`} variant="contained" endIcon={<ArrowForwardIcon/>} sx={{marginTop:"24px",color:"white"}} >START</Button>
            }
            {
              slug?.pos !== 0 &&
              <Button component={Link} to={`${slug?.last}`} variant="contained" endIcon={<ArrowForwardIcon/>} sx={{marginTop:"24px",color:"white"}} >CONTINUE</Button>
            }
        </Grid>
        <Grid size={5} display="flex" justifyContent="center" sx={{marginTop:"-48px"}}>
            <img className="assesmentMainImageBig" src={mainImage} alt="Assessment Logo"/>
        </Grid>
    </Grid>
  )
}

export default WelcomeIntro